var Options = {
  props: {
    /**
     * Leaflet options to pass to the component constructor
     */
    options: {
      type: Object,
      default: function () { return ({}); }
    }
  }
};

export default Options;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-leaflet/dist/mixins/Options.js
// module id = 628
// module chunks = 0